import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Zap } from "lucide-react";
import { CONTACT, WHATSAPP_MSG } from "../../data/site";

const LINKS = [
  { label: "Serviços", href: "#servicos" },
  { label: "Valores", href: "#valores" },
  { label: "Processo", href: "#processo" },
  { label: "Projetos", href: "#projetos" },
  { label: "Contato", href: "#contato" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,border,padding] duration-500 ${
        scrolled ? "glass border-b border-white/10 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <span className="grid place-items-center w-9 h-9 bg-coral text-white">
            <Zap size={18} strokeWidth={2.5} />
          </span>
          <span className="font-display font-extrabold tracking-tight leading-none text-white text-lg">
            TOTAL<span className="text-coral">.</span>
            <span className="block text-[9px] font-mono font-normal tracking-[0.25em] text-muted-fg uppercase">
              Engenharia & Serviços
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="font-mono text-xs uppercase tracking-widest text-muted-fg hover:text-white transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1.5 after:h-px after:w-0 after:bg-coral hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={`https://wa.me/${CONTACT.phoneRaw}?text=${WHATSAPP_MSG}`}
          target="_blank"
          rel="noreferrer"
          data-testid="nav-cta-whatsapp"
          className="hidden sm:inline-flex items-center gap-2 bg-coral hover:bg-coral-hover text-white font-semibold text-sm px-5 py-2.5 transition-colors duration-300"
        >
          Agendar Visita
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden glass border-t border-white/10 overflow-hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-display text-2xl font-bold text-white"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
